import { render, staticRenderFns } from "./kdQualityManagerInitiateRecallAudit.vue?vue&type=template&id=2e53621b&scoped=true"
import script from "./kdQualityManagerInitiateRecallAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdQualityManagerInitiateRecallAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53621b",
  null
  
)

export default component.exports